/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
import { withRouter, useHistory, RouteComponentProps } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import AttachmentIcon from "@material-ui/icons/Attachment";
import Delete from "@material-ui/icons/Delete";

import ReCAPTCHA from "core/components/ReCAPTCHA";

import { Typography } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { useTheme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import ArrowBack from "@material-ui/icons/ArrowBack";
import CircularProgress from "@material-ui/core/CircularProgress";

import BackButtonLayout from "core/layouts/backButtonLayout";
import { ErrorComponent } from "core/components/Error";
import { DescreptionText } from "core/components/Text";
import { Row, RowItem } from "core/components/Rows";
import Fail from "pages/Fail";
import { toBase64, isEmail, beginWith966, Alphanumeric } from "core/utils";

import { ContactUsApi } from "api";

import { Inputs, InquiryType, InquiryTypes, Props } from "./modals";
import { useStyles } from "./styles";
const recaptchaRef: any = React.createRef();

const ContactUs = (
  props: React.PropsWithChildren<Props & RouteComponentProps>
) => {
  const { t, i18n } = useTranslation();
  const win: any = window;
  const langDir = i18n.dir(win["lang"] as string);
  const isRTL = langDir === "rtl";
  const [open, setOpen] = useState(false);
  const [renderError, setRenderError] = useState(false);

  const [attachmentFormatError, setAttachmentFormatError] = useState(false);
  const thanksUrl = win["contactus_thanks_url"];
  const history = useHistory();
  const classes = useStyles();
  const theme = useTheme();
  const {
    register,
    handleSubmit,
    watch,
    errors,
    control,
    setValue,
  } = useForm<Inputs>();
  const {
    fristName,
    lastName,
    email,
    phoneNumber,
    otherPhoneNumber,
    inquiry,
    subject,
    message,
    attachment,
  } = watch();
  const [inquiryTypes, setInquiryTypes] = useState([]);
  const [loading, setLoading] = useState(false);

  const splitFileName = (filename: string) =>
    filename.toString().split("\\")[filename.toString().split("\\").length - 1];
  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };
  const onChange = (value: any) => {
    // setTrialCount(0);
    // recaptchaRef.current.reset();
    // console.log('Captcha value:', value);
  };
  useEffect(() => {
    ContactUsApi.getInquiryTypes()
      .then((res: any) => {
        !!res && setInquiryTypes(res.inquiryTypes as any);
      })
      .finally(() => console.log(""));
  }, []);

  const onSubmit = async (data: any) => {
    setLoading(true);
    if (!!attachment) {
      const attachmentSplited = attachment
        .toString()
        .replace(/^.*[\\\/]/, "")
        .split(".");

      if (attachmentSplited.length > 0) {
        const attachmentSplitedExtension =
          attachmentSplited[attachmentSplited.length - 1];
        const validFormats = ["doc", "docx", "pdf", "jpg", "png"];
        console.log(validFormats, attachmentSplitedExtension);
        if (!validFormats.includes(attachmentSplitedExtension)) {
          setAttachmentFormatError(true);
          setLoading(false);

          return;
        }
      }
    } else {
      setAttachmentFormatError(false);
    }
    const el = document.getElementById("attachment") as HTMLInputElement;
    const encodedFile = await toBase64(el);
    const payload = {
      contactInfo: {
        firstName: data.fristName,
        lastName: data.lastName,
        phoneNumber: data.phoneNumber,
        alternateContactNumber: data.otherPhoneNumber,
        emailAddress: data.email,
        inquiryType: data.inquiry,
        subject: data.subject,
        message: data.message,
        lang: i18n.language,
        docMapObject: {
          fileName: data.attachment
            ? data.attachment.replace(/^.*[\\\/]/, "")
            : "",
          fileByteArray: data.attachment ? encodedFile : "",
        },
      },
    };
    ContactUsApi.sendContactUsRequest(payload)
      .then((res: any) => {
        window.sessionStorage.thanksMessage = t("success_message");
        document.location.href = thanksUrl;
      })
      .catch((err) => setRenderError(true))
      .finally(() => setLoading(false));
  };

  return renderError ? (
    <Fail
      hideFail={() => {
        setRenderError(false);
      }}
    ></Fail>
  ) : (
    <BackButtonLayout>
      <Grid container direction="column">
        <Grid item sm={6} xs={12}>
          <Typography component={"span"} variant={"body2"}>
            <Box
              fontWeight={700}
              style={{
                direction: langDir,
              }}
              className={classes.pageTitle}
              fontSize={theme.spacing(9)}
              mb={theme.spacing(1)}
              letterSpacing={1}
            >
              {t("title")}
            </Box>
          </Typography>
        </Grid>
      </Grid>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Row>
          <RowItem>
            <Controller
              as={TextField}
              defaultValue={""}
              control={control}
              name="fristName"
              type={"string"}
              fullWidth
              label={t("firstname")}
              id="fristName"
              dir={langDir}
              rules={{ required: true, maxLength: 50, pattern: Alphanumeric }}
            />

            <ErrorComponent
              maxLength={50}
              nameLang={t("firstname")}
              patternMessage={t("kindlyUseAlphabeticCharcaters")}
              errors={errors}
              name={"fristName"}
            />
          </RowItem>
          <RowItem>
            <Controller
              as={TextField}
              defaultValue={""}
              control={control}
              name="lastName"
              type={"string"}
              rules={{ required: true, maxLength: 50, pattern: Alphanumeric }}
              fullWidth
              label={t("lastname")}
              id="lastName"
              dir={langDir}
            />
            <ErrorComponent
              maxLength={50}
              nameLang={t("lastname")}
              patternMessage={t("kindlyUseAlphabeticCharcaters")}
              errors={errors}
              name={"lastName"}
            />
          </RowItem>
        </Row>
        <Row>
          <RowItem>
            <Controller
              as={TextField}
              defaultValue={""}
              control={control}
              name="phoneNumber"
              type={"number"}
              rules={{
                required: true,
                maxLength: 15,
                minLength: 7,
              }}
              fullWidth
              label={t("phonenumber")}
              id="phoneNumber"
              dir={langDir}
            />
            <ErrorComponent
              maxLength={15}
              minLength={7}
              nameLang={t("phonenumber")}
              errors={errors}
              name={"phoneNumber"}
            />
          </RowItem>
          <RowItem>
            <Controller
              as={TextField}
              defaultValue={""}
              control={control}
              name="otherPhoneNumber"
              type={"number"}
              rules={{ maxLength: 15, minLength: 7 }}
              fullWidth
              label={t("otherPhonenumber")}
              id="otherPhoneNumber"
              dir={langDir}
            />
            <ErrorComponent
              maxLength={15}
              minLength={7}
              nameLang={t("otherPhonenumber")}
              errors={errors}
              name={"otherPhoneNumber"}
            />
          </RowItem>
        </Row>
        <Row>
          <RowItem>
            <Controller
              as={TextField}
              defaultValue={""}
              control={control}
              name="email"
              type={"string"}
              fullWidth
              rules={{
                required: true,
                minLength: 7,
                maxLength: 200,
                pattern: isEmail,
              }}
              label={t("email")}
              id="email"
              dir={langDir}
            />
            <ErrorComponent
              patternMessage={t("emailPatternError")}
              maxLength={200}
              minLength={7}
              nameLang={t("email")}
              errors={errors}
              name={"email"}
            />
          </RowItem>
        </Row>

        <Row style={{ marginTop: theme.spacing(10.5) }}>
          <RowItem style={{ width: "calc(50% - 7.5px)" }}>
            <InputLabel id="inquiry">{t("inquiry")}</InputLabel>
            <Controller
              as={
                <Select labelId="inquiry" id="inquiry">
                  {inquiryTypes.map((inquiry: InquiryType, index: number) => (
                    <MenuItem
                      key={index}
                      value={
                        i18n.language == "en"
                          ? inquiry.itemNameEn
                          : inquiry.itemNameAr
                      }
                    >
                      {i18n.language == "en"
                        ? inquiry.itemNameEn
                        : inquiry.itemNameAr}
                    </MenuItem>
                  ))}
                </Select>
              }
              defaultValue={""}
              control={control}
              name="inquiry"
              type={"string"}
              fullWidth
              id="inquiry"
              dir={langDir}
              open={open}
              onClose={handleClose}
              onOpen={handleOpen}
              rules={{ required: true }}
              // onChange={handleChange}
            />
            <ErrorComponent errors={errors} name={"inquiry"} />
          </RowItem>
        </Row>
        <Row>
          <RowItem>
            <Controller
              as={TextField}
              defaultValue={""}
              control={control}
              name="subject"
              type={"string"}
              fullWidth
              rules={{
                required: true,
                maxLength: 100,
                minLength: 1,
                pattern: Alphanumeric,
              }}
              label={t("subject")}
              id="subject"
              dir={langDir}
            />
            <ErrorComponent
              maxLength={100}
              minLength={1}
              nameLang={t("subject")}
              errors={errors}
              name={"subject"}
              patternMessage={t("kindlyUseAlphabeticCharcaters")}
            />
          </RowItem>
        </Row>

        <DescreptionText
          style={{
            fontSize: theme.spacing(1.5),
            color: "#008CFF",
            cursor: "pointer",
          }}
          text={t("how_can_help")}
        />
        <Row>
          <RowItem className={classes.bigTextField}>
            <Controller
              as={TextField}
              defaultValue={""}
              multiline
              rowsMax={4}
              control={control}
              name="message"
              type={"string"}
              fullWidth
              placeholder={t("type_message")}
              rules={{ required: true, maxLength: 100 }}
              id="message"
              dir={langDir}
            />
            <ErrorComponent
              maxLength={100}
              nameLang={t("message")}
              errors={errors}
              name={"message"}
            />
            <DescreptionText
              style={{
                fontSize: theme.spacing(1),
                color: "#868D95",
                cursor: "pointer",
                direction: langDir,
              }}
              text={`${String(message).length} ${t("of")} 100`}
            />
          </RowItem>
        </Row>

        <Row>
          <RowItem style={{ width: "calc(50% - 7.5px)" }}>
            <Controller
              as={TextField}
              defaultValue={""}
              control={control}
              name="attachment"
              type={"file"}
              fullWidth
              style={{ display: "none" }}
              id="attachment"
            />

            <Typography
              component={"span"}
              variant={"body2"}
              onClick={() => {
                if (!!!attachment) {
                  const el: any = document.getElementById(
                    "attachment"
                  ) as HTMLInputElement;
                  el.click();
                }
              }}
              style={{
                cursor: "pointer",
                border: "0px solid #D5D8DF",
                borderBottomWidth: "1px",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <Box
                fontWeight={400}
                width={"100%"}
                fontSize={theme.spacing(1.5)}
                letterSpacing={1}
              >
                {attachment
                  ? splitFileName(attachment.toString())
                  : t("attachDocument")}
              </Box>
              <Box fontSize={theme.spacing(1.5)} letterSpacing={1}>
                {!!!attachment ? (
                  <AttachmentIcon style={{ color: "#008CFF" }} />
                ) : (
                  <Delete
                    onClick={() => {
                      // setValue('attachment', undefined, {
                      //     shouldValidate: true,
                      //     shouldDirty: true,
                      // });
                      setValue("attachment", "");
                      const el: any = document.getElementById(
                        "attachment"
                      ) as HTMLInputElement;
                      el.files !== null && (el.files = undefined);
                    }}
                    style={{ color: "#008CFF" }}
                  />
                )}
              </Box>
              <Box />
            </Typography>
            <ErrorComponent
              customError={true}
              patternMessage={
                attachmentFormatError ? t("envalidFileFormate") : ""
              }
              name={"attachment"}
            />
          </RowItem>
        </Row>

        <Grid>
          <Button
            onClick={() => {
              if (
                !(
                  Object.keys(errors).length === 0 &&
                  errors.constructor === Object
                )
              ) {
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
                return;
              }
            }}
            type="submit"
            variant="contained"
            color="secondary"
            className={classes.button}
            disabled={
              loading ||
              !(
                fristName &&
                lastName &&
                email &&
                phoneNumber &&
                subject &&
                message &&
                inquiry
              )
            }
            endIcon={
              !isRTL ? (
                <ArrowForwardIcon
                  style={{ color: "#fff", cursor: "pointer" }}
                  fontSize={"default"}
                />
              ) : (
                <ArrowBack
                  style={{ color: "#fff", cursor: "pointer" }}
                  fontSize={"default"}
                />
              )
            }
          >
            <Box mr={8} color={"white"}>
              {t("send")}
            </Box>
            {loading && (
              <CircularProgress size={24} className={classes.buttonProgress} />
            )}
          </Button>
          <ReCAPTCHA onChange={onChange} recaptchaRef={recaptchaRef} />
        </Grid>
      </form>
    </BackButtonLayout>
  );
};
export default withRouter(ContactUs);
